import React, { useEffect, useState } from 'react';
import {
  Heading,
  Box,
  Button,
  Typography,
  CloseIcon,
  ButtonBase,
} from 'components';
import {
  useSubscription,
  deleteCareerOppPost,
  getUserCareerOppPosts,
  getDecoratedCareerOppPosts,
} from 'utils';
import isAfter from 'date-fns/isAfter';
import { PACKAGE_POST_COUNTS, SUBSCRIPTIONS_ENABLED } from '../../../constants';

const CareerDevList = ({ history, markets, user }) => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    if (!markets) return;
    getUserCareerOppPosts().then((_posts) =>
      getDecoratedCareerOppPosts(markets, _posts).then(setPosts),
    );
  }, [markets]);

  const onEdit = (id) => () => history.push(`/career_dev/edit/${id}`);

  const onAdd = () => history.push('/career_dev/create');

  const onDelete = (id) => () => {
    const confirm = window.confirm('Are you sure?');
    if (confirm) {
      deleteCareerOppPost(id).then(() =>
        setPosts((p) => p.filter((_p) => _p.id !== id)),
      );
    }
  };
  
  const { subscription } = useSubscription(user?.id);

  const maxPosts =
    PACKAGE_POST_COUNTS[subscription?.product?.id || 'prod_JqW9QrTHa0KHMP'];

  const activePosts = posts.filter(
    (p) => p.endDate && isAfter(p.endDate?.toDate(), new Date()),
  );

  const allowNewPost = activePosts.length < maxPosts;

  return (
    <>
      <Heading>Active Career Development Posts</Heading>
      <Typography align="center">
        You can post up to {maxPosts} active career development posts. You have{' '}
        {maxPosts - activePosts.length} remaining.
      </Typography>
      <Box my={4}>
        {activePosts.map((post) => (
          <CareerDevPostItem
            key={post.id}
            post={post}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        ))}
      </Box>

      <Button
        disabled={!allowNewPost}
        style={{ width: '100%', marginBottom: 12 }}
        variant="contained"
        color="primary"
        onClick={onAdd}
      >
        Add new career development post
      </Button>

      {SUBSCRIPTIONS_ENABLED && (
        <Button
          disabled={!allowNewPost}
          style={{ width: '100%' }}
          component="a"
          href="/packages"
          variant="contained"
          color="primary"
        >
          Upgrade plan
        </Button>
      )}
    </>
  );
};

export default CareerDevList;

const CareerDevPostItem = ({ post, onEdit, onDelete }) => (
  <Box display="flex" alignItems="center" justifyContent="space-between" my={4}>
    <Box flex={1}>
      <Typography variant="h5" style={{ fontWeight: 'normal' }}>
        {post.trainingType}, {post.company}
      </Typography>
    </Box>
    <Box>
      {onEdit && (
        <Button
          style={{ marginRight: 12 }}
          variant="outlined"
          onClick={onEdit(post.id)}
        >
          Edit
        </Button>
      )}
      <ButtonBase onClick={onDelete(post.id)}>
        <CloseIcon style={{ fill: 'red' }} />
      </ButtonBase>
    </Box>
  </Box>
);
